export const SPLIT_REGEX = /[0-9\.]+|[\+\*\/\-\>\<\=]|\[.*?\]|(Exp)|[\S]{1}|\s/g
export const NUMBER_REGEX = /^[0-9.]+$|(Math.E)/
export const OPERATOR_REGEX = /^[\+\*\/\-\>\<\=]$|(Exp)/
export const PARAMETER_REGEX = /^\[.*?\]$/